import { Fragment, useCallback } from 'react';
import { t } from '@lingui/core/macro';
import { Button, ButtonGroup, IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { SearchAggregationType } from 'shared/domains/apollo/generated/types';
import { SearchableMenu } from 'shared/domains/common-ui/SearchableMenu';
import { allowedProperties, isHeader, isItem } from './utils';
import { getDefaultDateHistogramValue } from '../DateHistogramInput/getDefaultDateHistogramValue';
import { getDefaultDateRangeValue } from '../DateRangeInput/getDefaultDateRangeValue';
import { getDefaultMetricValue } from '../MetricInput/getDefaultMetricValue';
import { getDefaultTermsValue } from '../TermsInput/getDefaultTermsValue';
import { getDefaultTopHitsValue } from '../TopHitsInput/getDefaultTopHitValue';
export function SelectDataPoint(props) {
    const { name, label, icon, onRemove, selectedValue } = props;
    const [, , helpers] = useField(name);
    const selectValue = useCallback((aggregationType, value) => {
        const setValue = (data) => {
            helpers.setTouched(true);
            helpers.setValue(data);
        };
        const getDefaultValueFunctions = {
            [SearchAggregationType.DateHistogram]: getDefaultDateHistogramValue,
            [SearchAggregationType.DateRange]: getDefaultDateRangeValue,
            [SearchAggregationType.Metric]: getDefaultMetricValue,
            [SearchAggregationType.Terms]: getDefaultTermsValue,
            [SearchAggregationType.TopHits]: getDefaultTopHitsValue,
        };
        const getDefaultValue = getDefaultValueFunctions[aggregationType];
        if (getDefaultValue) {
            setValue(getDefaultValue(value));
        }
    }, [helpers]);
    return (<ButtonGroup>
      <SearchableMenu items={allowedProperties()} keys={['value']} placeholder={t({
            message: 'Search',
            comment: 'Insights widget form: Data point selection search input',
        })} renderTarget={<Button type="button" size="small" appearance="secondary">
            {icon}
            {!selectedValue && label}
            {selectedValue}
          </Button>}>
        {({ items }) => items.map((item) => (<Fragment key={item.id}>
              {isHeader(item) && <Menu.Label key={item.id}>{item.label}</Menu.Label>}

              {isItem(item) && (<Menu.Item key={item.value} onClick={() => selectValue(item.type, item.value)}>
                  {item.label}
                </Menu.Item>)}
            </Fragment>))}
      </SearchableMenu>
      {onRemove && (<IconButton type="button" size="small" appearance="secondary" onClick={onRemove} aria-label={t({
                message: 'Remove',
                comment: 'Insights widget form: Data point selection remove button',
            })}>
          <Falcon icon="close"/>
        </IconButton>)}
    </ButtonGroup>);
}
